module.exports = __webpack_public_path__ + "static/banner-four-shape2-155b3bccb2829e04d7896dc9a22b0bc4.png";